import React from "react";
import { QRCodeCanvas } from "qrcode.react";
import { Image } from "antd";
import errorImag from "@/assets/images/common/errorImg.png";
import dzsjImg from "@/assets/images/common/dzsj.png";

const size = 175;
const logo = {
  src: dzsjImg,
  height: 40,
  width: 40,
}

const RenderQRcode = (props) => {
  const { type, data } = props;
  const { qrcode } = data || {};
  if (type === "ENTERPRISE") {
    return <QRCodeCanvas size={size} value={qrcode} title="电子税务局APP" imageSettings={logo} />;
  }
  return (
    <Image
      src={qrcode && `data:image/png;base64,${qrcode}`}
      alt="个人所得税APP"
      style={{ width: size, height: size }}
      preview={false}
      fallback={errorImag}
    />
  );
};

export default RenderQRcode;
